<template>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm cancellation</v-card-title>
        <v-card-text>Are you sure you want to cancel {{ heho.heho_nr }} {{ heho.plan_code }} Arrival {{heho.heho_van_datum}}  Departure {{heho.heho_tm_datum}} ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="warning mx-2" small @click="cancelHeho">Yes</v-btn>
          <v-btn color="success"  small @click="dialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    
    <script>
    export default {
      data() { 
        return {
          dialog: false,
          heho: {}
        }
      },
      methods: {
        open(heho_encrid,huis_encrid) {
          this.$emit("showSnackbar");
          this.dialog = true;
          this.$axios
            .post("ares/json/ares/heho/getHehoToCancel.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "getHehoToCancel"
              },
              getHehoToCancel: {
                heho_encrid: heho_encrid,
                huis_encrid: huis_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              } else {
                this.heho = res.data.getHehoToCancel;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        },
        cancelHeho() { 
          this.$axios
            .post("ares/json/ares/heho/cancelHeho.p", {
              header: {
                token: this.$session.get("ARES"),
                clientSessionId: this.$session.id(),
                request: "cancelHeho"
              },
              cancelHeho: {
                heho_encrid: this.heho.heho_encrid,
                huis_encrid: this.heho.huis_encrid
              }
            })
            .then(res => {
              if (res.data.error) {
                console.log(res.data.error);
              }  else { 
                window.opener.location.reload();
                this.$router.reload('/heho/onHeho/' + res.data.cancelHeho.heho_encrid + '/' + res.data.cancelHeho.huis_encrid);  
                 
                 /* window.close(); */
                 
                 this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.cancelHeho.text,
                  color: res.data.cancelHeho.color
                });           
                this.dialog = false; 
              }
            })
        },
      }
    }
    </script>
    
    